

import { toggleModal, ADD_ACTIVITY_LOG_TO_LIST } from "./mutation-types";

export default {

        [toggleModal]: (state, value) =>{
            state.isShowAddOrUpdateModal = value;
        },

        [ADD_ACTIVITY_LOG_TO_LIST]: (state, activityLogList) =>{
                activityLogList.forEach(element => {
                    element.description = "Received " + element.points + " points from " + element.givenBy.fname + " " + element.givenBy.lname
                    
                    element.description_long = "<b><i>" + element.givenBy.fname + " " + element.givenBy.lname + "</i></b> gave " +"<b><i>" + element.points +
                     " </i></b> points to <b><i>"  +  element.givenTo.fname + " " + element.givenTo.lname + "<i></b> for " + element.subCategory.name
                    
                });
      
  
            state.activityLogList = activityLogList ;
        },  
}
